<template>
  <v-container class="grey lighten-5">
    <div class="pa-3 display-1" id="title">
      マイ機器
    </div>
  <v-card class="py-5">
    <span class="title px-3 my-3">マイ機器一覧</span>
    <span class="caption px-3">登録済みのマイ機器一覧です。マイ機器名、マイ機器IDで検索することができます。</span>
    <v-row>
      <v-col cols="2" v-if="AnalizeTypeCategory=='航空機'">
        <div class="px-3">
          <v-select
            v-model="category"
            :items="categorys"
            item-text="text"
            item-value="type"
            label="分析区分で絞り込み"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="2" v-if="AnalizeTypeCategory=='航空機'">
        <div class="px-3">
          <v-select
            v-model="type"
            :items="types"
            item-text="text"
            item-value="type"
            label="種別で絞り込み"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="px-3">
        <v-text-field
          v-model="searchID"
          prepend-inner-icon="mdi-magnify"
          placeholder="マイ機器ＩＤで検索"
        ></v-text-field>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="px-3">
        <v-text-field
          v-model="searchName"
          prepend-inner-icon="mdi-magnify"
          placeholder="マイ機器名で検索"
        ></v-text-field>
        </div>
      </v-col>
    </v-row>



    <v-row>      
      <v-col cols="12" class="mx-3">
        <v-tooltip top color="grey darken-2">
          <template v-slot:activator="{ on }">
<!--
            <v-btn v-on="on" rounded color="amber" :to="{ path: 'selectmachinetype' }"> <v-icon>mdi-plus</v-icon> マイ機器を登録</v-btn>
-->
            <v-btn v-on="on" rounded color="amber" @click="gotoCreateMachine"> <v-icon>mdi-plus</v-icon> マイ機器を登録</v-btn>

          </template>
          <span>新しくマイ機器を登録する場合にこのボタンをクリックしてください。</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="machineListHeaders"
          :items="machines"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :sort-by="['Name']"
          :sort-desc="[false]"
          :loading="loading"
          class="elevation-1"
          loading-text="読込中"
          no-data-text="データがありません。"                    
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectMachine"
          id="row-pointer"
        >
          <template v-slot:[`item.LatestOrderAt`]="{ item }">
            <span v-show="item.LatestOrderAt"> {{ item.LatestOrderAt | moment('YYYY[/]MM[/]DD') }} </span>
            <span v-show="!item.LatestOrderAt"> なし </span>
          </template>
          <template v-slot:[`item.TotalOperatingTime`]="{ item }">
            <span> {{ item.TotalOperatingTime }} {{ item.TotalOperatingTimeUnitText }} </span>
          </template>
          <template v-slot:[`item.Type`]="{ item }">
            <v-chip v-if="item.Type=='機体'" color="green darken-4" text-color="white" >機体</v-chip>
            <v-chip v-else-if="item.Type=='装置装備'" color="green" text-color="white" >装備品</v-chip>
            <v-chip v-else color="green" text-color="white" >装備品</v-chip>
          </template>
          <template v-slot:[`item.AnalizeType`]="{ item }">
            <span v-if="!item.AnalizeType"> 一般</span>
            <span v-else-if="item.AnalizeType.substr(0,1) == '1'"> 一般</span>
            <span v-else-if="item.AnalizeType.substr(0,1) == '2'"> 航空機</span>
            <span v-else>その他</span>
          </template>

          <!-- <template v-slot:item.id="{ item }">
            <v-tooltip left color="grey darken-2">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" fab x-small elevation="1" color="amber" :to="{ path: 'sampling/', query: { id: item.id }}" class="mx-2 caption" id="sample_btn">
                  <v-icon 
                    small 
                    >mdi-cup-water</v-icon>
                </v-btn>
              </template>
              <span>クリックすると、分析サンプルの採取登録画面へ遷移します</span>
            </v-tooltip>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" md='10' sm='12'>
        <v-pagination
          v-model="page"
          :total-visible="totalVisible"
          :length="pageCount"
          color="amber black--text"
          light 
          circle
        >
        </v-pagination>
      </v-col>
      <!-- <v-col cols="2" md='2' sm='4'>
        <v-text-field
          :value="itemsPerPage"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-text-field>
      </v-col> -->
      <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>
  </v-card >    
  </v-container>
</template>

<script>
import { fetchAllMachineByOffice } from '../utils/utils'

export default {
  name: 'MyMachineList',
  head: {
    title: { inner: 'マイ機器一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      totalVisible: 7,
      itemsPerPage: 10,
      itemsPerPageList: [ 5,10,30 ],
      LatestOrderAt: "",
      loading: false,      
      machineListHeadersJET: [
        {
          text: '分析区分',
          align: 'start',
          value: 'AnalizeType',
          class: "grey darken-2 white--text",
          width: '10%',
          filter: this.categoryFilter,
        },
        {
          text: '種別',
          align: 'start',
          value: 'Type',
          class: "grey darken-2 white--text",
          width: '10%',
          filter: this.typeFilter,
        },
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text",
          width: '20%',
          filter: this.idFilter,
        },
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '35%',
          filter: this.nameFilter,
        },
        {
          text: '使用時間',
          align: 'end',
          value: 'TotalOperatingTime',
          class: "grey darken-2 white--text"

        },
        // {
        // text: '採取',
        // value: 'id',
        // class: "grey darken-2 white--text"
        // },

      ],
      machineListHeadersStandard: [
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text",
          width: '20%',
          filter: this.idFilter,
        },
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '35%',
          filter: this.nameFilter,
        },
        {
          text: '使用時間／距離',
          align: 'end',
          value: 'TotalOperatingTime',
          class: "grey darken-2 white--text"

        },
      ],
      types: [
        { type: "all", text: 'すべて' },
        { type: "機体", text: '機体' },
        { type: "装備装置", text: '装備品' },
      ],
      categorys: [
        { type: "一般", text: '一般' },
        { type: "航空機", text: '航空機' },
      ],
      category:"航空機",
      type: "all",
      searchID: '',
      searchName: '',
      machines: [],
      AnalizeTypeCategory: "一般",
    }
  },
  mounted: async function () {
    //  全カラムの一覧を取る場合はこの1行でOK
    //  let machines = await API.graphql(graphqlOperation(listMachines, {limit: 100, items: "Name,  CustomerMachineID, OperatingTime, OperatingTimeUnit"}))
    //  取得するカラムを指定する場合はこのように書く。
    this.loading = true
      this.AnalizeTypeCategory = this.$store.state.operatingCompany.AnalizeTypeGroup

//    let page = this.$route.query.page
      this.machines = await fetchAllMachineByOffice(this.$store.state.operatingOffice.OfficeID)
      console.log(this.machines);
//      this.page = Number(page)

      // 航空機のマイ機器情報（装備品）は、マイ機器名＝関連づく機体.マイ機器名とする
      // slotでの置き換えだとソートがうまくいかないためデータの置換で対応
      for (const machine of this.machines) {
        if(machine.MountedMachineID) {
          machine.Name = this.getAircraftName(machine.MountedMachineID)
        }
      }

      this.loading = false
  },
  methods: {
    categoryFilter(value) {
      if(value != null) {
        if(this.category == "一般"){
          return value.startsWith("1")
        }else {
          return value.startsWith("2")
        }
      }else {
        return true
      }
    },
    typeFilter(value){
      if(this.type == "all"){
        return true
      }else if(this.type == "機体"){
        if(value == null) {
          return false
        }else {
          return value.toLowerCase().includes("機体");
        }
      }else{
        if(value == null) {
          return true
        }else {
          return value.toLowerCase().includes("装備装置");
        }
      }
    },
    idFilter(value){
      if (!this.searchID) {
        return true
      }
      return value.toLowerCase().includes(this.searchID.toLowerCase());
    },
    nameFilter(value){
      if (!this.searchName) {
        return true
      }
      return value.toLowerCase().includes(this.searchName.toLowerCase());
    },

    getAircraftName: function(id) {
      if(id) {
        const aircraft = this.machines.filter(item => item.id  == id)
        let name = ""
        if(aircraft[0]) {
          name = aircraft[0].Name
        }else {
          name = "不明な機体"
        }
        return name
      }else{
        return ""
      }
    },

    gotoCreateMachine: function() {
//      let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
//      console.log("得意先.依頼区分:", AnalizeTypeGroup)
      // 得意先.依頼区分が一般の場合はマイ機器作成（一般、装備・装置）
      if(this.AnalizeTypeCategory == "一般") {
          this.$router.push("/mymachine?type=" + "装備装置" + "&category=" + "一般")
      // 得意先.依頼区分が航空機の場合、登録マイ機器の種別選択画面
      }else {
        this.$router.push("/selectmachinetype")
      }
    },

    selectMachine: function(data) {
      console.log("selectMachine", data)
      if(data.Type == "機体") {
        this.$router.push("myaircraft?id=" + data.id)
//        this.$router.push("myaircraft?id=" + data.id + "&page=" + this.page)
      }else {
        this.$router.push("/mymachine?id=" + data.id)
//        this.$router.push("/mymachine?id=" + data.id + "&page=" + this.page)
      }
    },
  },
  computed : {
    machineListHeaders() {
//      let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
      if (this.AnalizeTypeCategory == '一般') {
        return this.machineListHeadersStandard
      }else {
        return this.machineListHeadersJET
      }
    },
  }
}
</script>
<style lang="css" scoped>
#row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>